import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { DataService } from 'src/app/Service/data.service';
import { UnidadMedida } from 'src/app/Models/unidadmedida/unidad-medida';
import { AlertComponent } from '../../objects/alert/alert/alert.component';
import { LoadingComponent } from '../../objects/loading/loading.component';
import { InfoComponent } from '../../objects/info/info/info.component';
import { ALertOption } from 'src/app/Models/alert/alert-option';
import { UnidadSunat } from 'src/app/Models/unidadsunat/unidad-sunat';
@Component({
    selector: 'app-unidad-medida',
    templateUrl: './unidad-medida.component.html'

})
export class UnidadMedidaComponent implements OnInit {
    @ViewChild('btnshow', null) btnshow: ElementRef;
    @ViewChild('btnclose', null) btnclose: ElementRef;
    
    @ViewChild(AlertComponent, null) alert: AlertComponent;
    @ViewChild(LoadingComponent, null) loading: LoadingComponent;
    @ViewChild(InfoComponent, null) info: InfoComponent;
    public isShow: boolean = false;
    public pagina: number = 0;
    public unidades:UnidadMedida[]=[];
    public unidadsunats:UnidadSunat[] =[];
    public unidad:UnidadMedida= new UnidadMedida();
    public isEdit:boolean=false;
    public funcion:Function=null;
    public pagunidadm:any;
    public adddescripcion:boolean = false;
    public waitunidadsunat:boolean = false;
    constructor(private data: DataService) { }

    ngOnInit() {
        this.unidad.unidad = "";
        this.unidad.codigo ="";
    }

    public show(affterfunction:Function = null) {
        this.funcion= affterfunction;
        this.isShow = true;
        this.showTab(1);
        
        setTimeout(() => {
            this.btnshow.nativeElement.click();
            this.GetUnidadMedida();
            this.GetUnidadSunat();
        }, 10);
    }

    GetUnidadMedida(){
        this.loading.show("cargando..");
        
        this.data.GetSimple(this.data.api.unidadmedida).subscribe(r=>{
            if (r.length>0) {
                
                this.unidades = r;
                this.loading.hide();
            }else{
                console.log("no hay unidades");
                this.loading.hide();
            }
        },e=>{this.loading.hide(); this.info.error(e,()=>{this.showTab(1)})})
    }
    async GetUnidadSunat() {
        this.waitunidadsunat = true;
        await this.data.AsyncGetSimple(this.data.api.unidadsunat).then(r => {
            if (r.length>0) {
                this.unidadsunats = r;
                this.waitunidadsunat= false;
            }
        }).catch(e=>{console.log(e)});
    }
    ShowNewItem(){
        this.isEdit = false;
        this.showTab(2);
        this.unidad = new UnidadMedida();
        this.adddescripcion = false;
        
    }
    ShowEditItem(i){
        this.isEdit = true;
        this.showTab(2);
        this.unidad = i as UnidadMedida;
        //if(this.unidad.descripcion != ""){this.adddescripcion = true;}else{this.adddescripcion = false;}
    }
    showTab(i) {
        this.pagina = i;
    }

    close(){
        this.btnclose.nativeElement.click();
        setTimeout(() => {
            //this.isShow=false;
            if(this.funcion != null){
                this.funcion();
            }
        }, 10);
    }

    Save(){
        if(this.isEdit){
            this.loading.show("Actualizando..");
            this.unidad.usuario_id = this.data.getCurrentUser().id;
            this.data.Put(this.data.api.unidadmedida,this.unidad.idunidad.toString(),this.unidad).subscribe(r=>{
                this.loading.hide();
                this.info.show(r.message,2,null,null,()=>{this.showTab(1);this.GetUnidadMedida();})
            },e=>{this.loading.hide(); this.info.error(e,()=>{this.showTab(1)})})
        }
        else{
            this.loading.show("Registrando..");
            this.unidad.usuario_id = this.data.getCurrentUser().id;
            this.data.Post(this.data.api.unidadmedida,this.unidad).subscribe(r=>{
                console.log(r);
                
                this.loading.hide();
                this.info.show(r.message,2,null,null,()=>{this.showTab(1);this.GetUnidadMedida();})
            },e=>{this.loading.hide(); this.info.error(e,()=>{this.showTab(1)})})
        }
        if(this.funcion != null){
            this.funcion();
        }
    }

    ShowDeleteItem(i){
        this.unidad = i as UnidadMedida;
        this.data.notify('Estimado usuario, ¿Estas seguro de eliminar la unidad '+this.unidad.unidad+' del sistema?','ELiminar Unidad',this.data.alertType.question,new ALertOption(true,true),async ()=>{
           await this.data.AsyncDelete(this.data.api.unidadmedida,this.unidad.idunidad.toString()).then((r)=>{
                if(r.status == 'success'){
                    this.data.notify(r.message,'Proceso exitoso',this.data.alertType.success,new ALertOption(false,true,'Aceptar'));
                    this.GetUnidadMedida();
                }else{
                    this.data.notify(r.message,'Error al eliminar',this.data.alertType.error,new ALertOption(false,true,'Aceptar'));
                }
           });
        });
    }


}
